import React, { useEffect, useMemo } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import APIService from "../../Service/APIService";
import FormConfig from "../../Config/FormConfig";
import { Button, Flex, Spin, message, Upload, Checkbox } from "antd";
import CommonButton from "../../common/button/button.js";
import { useState } from "react";
import moment from "moment";
import "./InvoiceHomeCss.css";
import Swal from "sweetalert2";
import TitleBar from "../../common/title-bar/title-bar";
import dayjs from "dayjs";
import TableOptionsCellMenu from "../../common/table/table-options-cell/table-options-cell-menu.js";
import DetailsContainer from "../../common/details-container/index.js";
import ProgressContainer from "../../common/progress-container/index.js";
import DetailWrapper from "../../common/detail-wrapper/index.js";
import ModalView from "../../common/modal/index.js";
import TextInput from "../../common/text-input/index.js";
import DropdownComponent from "../../common/dropdown-input/index.js";
import DatePickerComponent from "../../common/date-picker/index.js";
import Text from "../../common/typography/text.js";
import CircularProgress from "../../common/circular-progress/index.js";
import Divider from "../../common/divider/divider.js";
import { formatNumber } from "../../common/card/index.js";
import ProgressBox from "../../common/progress-box/index.js";
import { useScreen } from "../Utils/Screens.js";
import TableOptionsCell from "../../common/table/table-options-cell/index.js";
import ApplyCommission from "../Commissions/ApplyCommissionNew.js";
import { LoadingOutlined } from "@ant-design/icons";
import Table from "../../common/table/index.js";
import { UploadOutlined } from "@ant-design/icons";
import ProductListModule from "./ProductListModule.js";
import FailureIcon from "../../icons/failure-icon.js";
import RightTopArrowIcon from "../../icons/right-top-arrow.js";
import { colors } from "../../theme/colors.js";
import { useAuth } from "../AuthProvider.js";
import { hasPermission } from "../../Config/permissions.js";
import { canResetPayments } from "../../Config/paymentAccess.js";
import { set } from "date-fns";
import NotesSection from "./NotesSection.js";
import CommentsSection from "./CommentsSection.js";
import SectionHeader from "../../common/section-header/index.js";
import AccountsIcon from "../../icons/accounts-icon.js";
import DistributorIcon from "../../icons/distributor-icon.js";
import { dummyNotesData } from "./DummyTestData.js";
import { Skeleton } from "antd";
import Tags from "../../common/tags/index.js";
import TabFade from "../../common/tab-fade";
import {
  formatCurrency,
  getPaymentAppliedDisplayTotal,
} from "../Utils/Helpers.js";
import MakeInvoicePaymentModal from "./MakeInvoicePaymentModal.js";
import { requestInvoiceAccountDetails } from "./invoiceAccountDetails.js";
import { canAddInvoicePayment } from "./invoicePaymentAccess.js";

const InvoiceHome = () => {
  const params = useParams();
  const { user } = useAuth();
  const userData = user;
  const canAddPayment = canAddInvoicePayment(userData);
  const [applyCommissionDisable, setApplyCommissionDisable] = useState(false);
  // const [fieldsArr, setFieldsArr] = React.useState([]);
  // const [editMode, setEditMode] = React.useState(false);
  const [invoiceData, setInvoiceData] = React.useState(null);

  const roundToTwo = (value) => {
    const num = Number(value);
    if (!Number.isFinite(num)) return 0;
    return Math.round(num * 100) / 100;
  };

  const isTruthyPrepaidOrder = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1";
    }
    return false;
  };

  const isTrueValue = (value) => {
    if (value === true || value === 1) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "true" || normalized === "1";
    }
    return false;
  };

  const isFalseValue = (value) => {
    if (value === false || value === 0) return true;
    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      return normalized === "false" || normalized === "0";
    }
    return false;
  };

  const normalizePaymentSource = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase();

  const hasStripePaymentReference = (row) =>
    Boolean(
      row?.StripeCheckoutAttemptID ||
        row?.StripeCheckoutSessionID ||
        row?.StripePaymentIntentID ||
        String(row?.CheckNumber ?? "").startsWith("pi_"),
    );

  const resolvePaymentSource = (row) => {
    const storedSource = normalizePaymentSource(row?.PaymentSource);
    if (storedSource) return storedSource;
    if (
      isTruthyPrepaidOrder(row?.IsAutomaticallyApplied) &&
      isTruthyPrepaidOrder(row?.PrepaidOrder)
    ) {
      return "direct_order_prepaid";
    }
    if (hasStripePaymentReference(row)) return "invoice_stripe";
    return "manual";
  };

  const [orderProducts, setOrderProducts] = React.useState(null);
  const [paymentsAppliedData, setPaymentsAppliedData] = React.useState(null);

  const [invoiceType, setInvoiceType] = React.useState(null);
  const [invoiceHomeData, setInvoiceHomeData] = React.useState(null);

  // API loaders
  const [isInvoiceDataLoading, setIsInvoiceDataLoading] = useState(true);
  const [isInvoiceCommissionLoading, setIsInvoiceCommissionLoading] =
    useState(true);
  const [isOrderDetailsLoading, setIsOrderDetailsLoading] = useState(true);
  const [isAccountDataLoading, setIsAccountDataLoading] = useState(true);

  const navigate = useNavigate();
  const location = useLocation();

  const getInvoiceData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getinvoicehomedata?ID=${params?.id}`,
    );
    console.log("Invoice Data: ", response);
    const invoice = response?.data?.data?.invoice;
    const ordDet = response?.data?.data?.orderDetails;
    const ordPro = response?.data?.data?.invoiceProducts;
    const invoiceNotes = response?.data?.data?.invoiceNotes;
    setApplyCommissionDisable(false);
    ordPro.forEach((element) => {
      // Do something with each element
      if (element.ReturnStarted && !element.ReturnCompleted) {
        setApplyCommissionDisable(true);
      }
    });
    console.log("Invoice: ", invoice);
    console.log("Order Details: ", ordDet);
    console.log("Order Products: ", ordPro);
    console.log("Invoice Notes: ", invoiceNotes);
    if (response?.status === 200) {
      setIsInvoiceDataLoading(false);
    }
    return response?.data?.data;
  };

  const generateInitialValues = (fieldVal, data = null) => {
    let obj = {};
    if (!data) {
      for (const cur of fieldVal) {
        obj[cur.backendName] = null;
      }
    } else {
      for (const cur of fieldVal) {
        obj[cur.backendName] =
          cur.backendName in data ? data[cur.backendName] : null;
      }
    }
    return obj;
  };

  const generateFieldsArray = (data, tempType = null) => {
    const invoiceFields = FormConfig.InvoiceHomeForm;
    const val = generateInitialValues(invoiceFields, data);

    tempType !== "Consignment Order" &&
      getInvoiceHomeCardData().then((data) => {
        setOpenBalance(
          roundToTwo(
            roundToTwo(data?.invoiceTotal) +
              roundToTwo(val?.ShippingCost) -
              roundToTwo(data?.totalPaymentsApplied),
          ),
        );
      });
  };

  const getPaymentsAppliedData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getpaymentsapplied?type=invoice&InvoiceID=${params.id}`,
    );
    return response?.data?.data;
  };

  const formatPaymentsAppliedRows = (data = []) =>
    data.map((payment) => ({
      ...payment,
      PaymentAppliedDisplayTotal: formatCurrency(
        getPaymentAppliedDisplayTotal(payment),
      ),
      AppliedTotal: formatCurrency(payment.AppliedTotal),
      AppliedDate: moment(payment.AppliedDate).format("MM-DD-YYYY"),
    }));

  const refreshPaymentsAppliedData = async () => {
    const data = await getPaymentsAppliedData();
    setPaymentsAppliedData(formatPaymentsAppliedRows(data || []));
  };

  const getInvoiceHomeCardData = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getinvoicehomecarddata?InvoiceID=${params.id}`,
    );
    return response?.data?.data;
  };

  const [formattedOrders, setFormattedOrders] = React.useState([]);
  const [openBalance, setOpenBalance] = React.useState(0);

  // NEW states
  const [accountDetails, setAccountDetails] = useState();
  // const [orderDetailsWrapper, setOrderDetailsWrapper] = useState();
  // form values
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [modalOpenVoid, setModalOpenVoid] = useState(false);
  const [modalOpenApplyComm, setModalOpenApplyComm] = useState(false);
  const [modalOpenApplyCommFull, setModalOpenApplyCommFull] = useState(false);
  const [modalOpenAddPayment, setModalOpenAddPayment] = useState(false);
  const [modalOpenMakePayment, setModalOpenMakePayment] = useState(false);
  const [modalOpenResetCommission, setModalOpenResetCommission] =
    useState(false);
  const [isCreatingInvoiceCheckout, setIsCreatingInvoiceCheckout] =
    useState(false);
  const [modalOpenEditPayment, setModalOpenEditPayment] = useState(false);
  const [modalOpenCollections, setModalOpenCollections] = useState(false);
  const [selectedCollectionProductIds, setSelectedCollectionProductIds] =
    useState([]);
  const [isSendingToCollections, setIsSendingToCollections] = useState(false);
  // edit form values
  const [invoiceNumberForm, setInvoiceNumberForm] = useState("");
  const [poNumberForm, setPoNumberForm] = useState("");
  const [shippingCostForm, setShippingCostForm] = useState("");
  const [shippingCostAssignedForm, setShippingCostAssignedForm] = useState("");
  const [invoiceDateForm, setInvoiceDateForm] = useState();
  const [dueDateForm, setDueDateForm] = useState();
  const [invoiceAppealForm, setInvoiceAppealForm] = useState();
  const [creditMemoForm, setCreditMemoForm] = useState();

  const [invoiceCommissionData, setInvoiceCommissionData] = useState();

  const isPhone = !useScreen("md");
  const [paymentsTableHeaders, setPaymentsTableHeaders] = useState([]);
  const [isNoteTypeSelected, setIsNoteTypeSelected] = useState();
  // Derive from the auth context (same source the rest of the app uses via
  // useAuth). Reading from localStorage here left this undefined because the
  // AuthProvider keeps the user in-memory only, which silently hid the
  // notes/comments section for every user, admins included.
  const userType = userData?.Type;
  const [invoiceNotesAccount, setInvoiceNotesAccount] = useState(null);
  const [invoiceNotesDistributor, setInvoiceNotesDistributor] = useState(null);
  const [invoiceComments, setInvoiceComments] = useState(null);
  const [invoiceFilesHistory, setInvoiceFilesHistory] = useState([]);
  const [isInvoiceFilesModalOpen, setIsInvoiceFilesModalOpen] = useState(false);
  const [isInvoiceFilesLoading, setIsInvoiceFilesLoading] = useState(false);
  const [invoiceFilesError, setInvoiceFilesError] = useState("");

  // this useEffect is for fetching invoice home data: invoice, order details, invoice products
  React.useEffect(() => {
    let tempType = "";
    getInvoiceData()
      .then((data) => {
        setInvoiceHomeData(data);
        if (userData?.Type === "Manufacturer") {
          if (data.invoice?.ManufacturerID != userData?.ManufacturerID) {
            navigate(`/Manufacturer/${userData?.ManufacturerID}`);
          }
        }
        if (userData?.Type === "Account") {
          // fetch account details
          fetchAccountDetails(data?.invoice?.AccountID).then((accData) => {
            if (accData?.IsChildAccount) {
              if (accData?.ParentAccountID != userData?.AccountID) {
                navigate(`/Account/${userData?.AccountID}`);
              }
            } else {
              if (data.invoice?.AccountID != userData?.AccountID) {
                navigate(`/Account/${userData?.AccountID}`);
              }
            }
          });
        }
        if (userData?.Type === "Distributor") {
          if (data.invoice?.DistributorID != userData?.DistributorID) {
            navigate(`/Distributor/${userData?.DistributorID}`);
          }
        }
        tempType = data?.invoice?.OrderType;
        setInvoiceType(data?.invoice?.OrderType);
        const orderDetails = data?.orderDetails;
        setInvoiceData(data?.invoice);
        setInvoiceNotesAccount(data?.invoiceNotesAccount);
        setInvoiceNotesDistributor(data?.invoiceNotesDistributor);
        setInvoiceComments(data?.invoiceComments);
        // remove "Options" header if not admin
        const filteredTableHeadersPaymentsAppliedInvoice =
          tableHeadersPaymentsAppliedInvoice.filter((header) => {
            if (header.headerName === "Options") {
              const isValid =
                userData.Type === "Admin" &&
                userData.IsSuperAdmin &&
                !data?.invoice.IsCommissionApplied;
              return isValid;
            }
            return true;
          });
        setPaymentsTableHeaders(filteredTableHeadersPaymentsAppliedInvoice);
        if (data?.invoice?.UploadInvoiceFileName) {
          setUploadInvoiceFileBlobName(
            data?.invoice?.UploadInvoiceFileBlobName,
          );
          setFileName(data?.invoice?.UploadInvoiceFileName);
          setUploadFileList([
            {
              name: data?.invoice?.UploadInvoiceFileName,
              status: "done",
              uid: "1",
            },
          ]);
        }
        // needed for order details on invoice home
        if (orderDetails) {
          const tempOrderDetails = {
            ...orderDetails,
            OrderDate: moment(orderDetails?.OrderDate).format(
              "MM-DD-YYYY - HH:mm",
            ),
            OrderTotal: formatCurrency(orderDetails?.OrderTotal),
            OrderType:
              orderDetails?.OrderType === "DO" ||
              orderDetails?.OrderType === "Direct Order"
                ? "Direct Order"
                : orderDetails?.OrderType === "CO"
                  ? "Consignment Order"
                  : orderDetails?.OrderType === "PU"
                    ? "Product Usage"
                    : orderDetails?.OrderType,
            Status: (
              <Button
                type={
                  orderDetails?.Status === "Completed" ? "primary" : "default"
                }
                shape="round"
                size="small"
                style={{
                  color:
                    orderDetails?.Status === "Approved"
                      ? "#27a907"
                      : orderDetails?.Status === "Completed"
                        ? "#fff"
                        : orderDetails?.Status === "Rejected"
                          ? "red"
                          : "default",
                  borderColor:
                    orderDetails?.Status === "Approved"
                      ? "#27a907"
                      : orderDetails?.Status === "Completed"
                        ? colors["primaryColor"]
                        : orderDetails?.Status === "Rejected"
                          ? "red"
                          : "default",
                  background:
                    orderDetails?.Status === "Completed"
                      ? colors["primaryColor"]
                      : "transparent",
                  width: "100%",
                }}
              >
                {orderDetails?.Status}
              </Button>
            ),
          };
          setFormattedOrders(tempOrderDetails);
        }
        setOrderProducts(
          data.invoiceProducts.map((product) => ({
            ...product,
            Price: formatCurrency(product.Price),
          })),
        );
        generateFieldsArray(data.invoice, tempType);
      })
      .then(() => {
        if (tempType !== "Consignment Order") {
          refreshPaymentsAppliedData();
        }
      });
  }, []);

  // this is to fetch the Account Details in invoice home heading
  useEffect(() => {
    if (invoiceData?.AccountID && userData?.Type !== "Account") {
      void fetchAccountDetails(invoiceData.AccountID);
    } else if (invoiceData?.ID && userData?.Type !== "Account") {
      setIsAccountDataLoading(false);
    }
  }, [invoiceData?.AccountID, invoiceData?.ID, userData?.Type]);

  // useEffect(() => {
  //   if (invoiceData?.OrderID && invoiceData?.OrderType) {
  //     fetchOrderDetails(invoiceData.OrderType, invoiceData.OrderID);
  //   }
  // }, [invoiceData?.OrderID, invoiceData?.OrderType]);

  const getDistCommPercentage = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getdistcommbyinvprods?InvoiceID=${invoiceData?.ID}`,
    );
    const res = response?.data?.error
      ? {
          error: true,
          message:
            response?.data?.message ||
            response?.data?.error ||
            "Unable to load distributor commission products.",
        }
      : response?.data?.data;
    return res;
  };
  const [distCommPayable, setDistCommPayable] = useState(0);
  const [distCommPayableDecimal, setDistCommPayableDecimal] = useState(0);
  const [distCommPayableTotal, setDistCommPayableTotal] = useState(0);
  const [distInvCommPercentage, setDistInvCommPercentage] = useState(null);
  const [isDistInvCommPercentageLoading, setIsDistInvCommPercentageLoading] =
    useState(false);
  useEffect(() => {
    if (invoiceData) {
      getDataComm();
      setDistInvCommPercentage(null);
      setIsDistInvCommPercentageLoading(true);
      getDistCommPercentage()
        .then((data) => {
          // setDistCommPercentageData(data)
          setDistInvCommPercentage(data);
          const invProds = Array.isArray(data) ? data : [];
          let totalDistPayable = 0;
          invProds.forEach((prod) => {
            totalDistPayable +=
              (Number(prod.Price) *
                Number(prod.DistributorCommissionPercentage)) /
              100;
          });
          setDistCommPayableTotal(totalDistPayable);
          const [distPayable, distPayableDecimal] =
            formatNumber(totalDistPayable).split(".");
          setDistCommPayable(distPayable);
          setDistCommPayableDecimal(distPayableDecimal);
        })
        .catch((error) => {
          setDistInvCommPercentage({
            error: true,
            message:
              error?.response?.data?.message ||
              error?.response?.data?.error ||
              "Unable to load distributor commission products.",
          });
          setDistCommPayableTotal(0);
          const [distPayable, distPayableDecimal] = formatNumber(0).split(".");
          setDistCommPayable(distPayable);
          setDistCommPayableDecimal(distPayableDecimal);
        })
        .finally(() => {
          setIsDistInvCommPercentageLoading(false);
        });
    }
  }, [invoiceData?.ID]);

  useEffect(() => {
    if (invoiceData) {
      setInvoiceNumberForm(invoiceData?.InvoiceNumber);
      setPoNumberForm(invoiceData?.PONumber);
      setShippingCostForm(invoiceData?.ShippingCost);
      setShippingCostAssignedForm(invoiceData?.ShippingCostAssignedTo);
      setInvoiceDateForm(dayjs(invoiceData?.InvoiceDate));
      setDueDateForm(dayjs(invoiceData?.InvoiceDueDate));
      setCreditMemoForm(invoiceData?.CreditMemo);
    }
  }, [invoiceData]);

  const submitHandler = async (values) => {
    const newObj = {
      ID: invoiceData?.ID,
      InvoiceNumber: invoiceNumberForm
        ? invoiceNumberForm
        : invoiceData?.InvoiceNumber,
      PONumber: poNumberForm ? poNumberForm : invoiceData?.PONumber,
      FullyPaidDate: invoiceData?.FullyPaidDate,
      InvoiceDate: invoiceDateForm,
      InvoiceDueDate: dueDateForm,
      InvoiceInAppeal: invoiceAppealForm?.label,
      InvoiceTotal: invoiceData?.InvoiceTotal,
      ShippingCost: shippingCostForm,
      DistributorID: invoiceData?.DistributorID,
      DistributorName: invoiceData?.DistributorName,
      TotalPaymentsApplied: invoiceData?.TotalPaymentsApplied,
      ShippingCostAssignedTo: shippingCostAssignedForm?.label,
      IsVoided: invoiceData?.IsVoided,
      CreditMemo: creditMemoForm,
    };
    // console.log("Form Values New: ", newObj);
    // return;
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the invoice",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const postObj = {
          invoiceData: newObj,
          type: "update",
          isFileUpdated: isFileUpdated,
        };
        const apiServe = new APIService();
        const formData = new FormData();
        formData.append("data", JSON.stringify(postObj));
        formData.append("file", uploadInvoice);
        const response = await apiServe.addFileDataToBackend(
          formData,
          "updateinvoice",
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Updated!", "Invoice Updated!", "success").then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Invoice Update Failed",
            text: "Please try again",
          });
        }
      } else {
        // console.log("Cancelled");
      }
    });
  };

  const handleOk = async () => {
    // add account to distributor
    const apiServe = new APIService();
    const invoiceObj = {
      ID: params?.id,
      CreditMemo: tempCreditMemo,
      OrderID: invoiceData?.OrderID,
      OrderType: invoiceData?.OrderType,
    };
    const postObj = {
      invoiceData: invoiceObj,
      type: "void",
    };
    const formData = new FormData();
    formData.append("data", JSON.stringify(postObj));
    formData.append("file", uploadInvoice);

    const response = await apiServe.addFileDataToBackend(
      formData,
      "updateinvoice",
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    if (response?.status === 200 || response?.status === 201) {
      Swal.fire("Voided!", "Invoice Voided!", "success").then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Invoice Void Failed",
        text: "Please try again",
      });
    }
    // setModalOpen(false);
    setModalOpenVoid(false);
  };

  const [editCheckNumber, setEditCheckNumber] = useState(null);
  const [editAppliedTotal, setEditAppliedTotal] = useState(null);
  const [editPaymentType, setEditPaymentType] = useState(null);

  const [showViewProduct, setShowViewProduct] = useState(false);

  const applyCommissionInFull = async () => {
    // setIsApplyCommissionFull(true)
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to apply commission in full",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Yes, apply it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend(
          {
            ...invoiceData,
            InvoiceID: invoiceData?.ID,
            DateApplied: appliedDate,
            StatementMonth: statementMonthComm,
          },
          `applycommissioninfull`,
        );
        // console.log("Apply Commission Response: ", response);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Applied!", "Commission Applied!", "success").then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Commission Application Failed",
            text: "Please try again",
          });
        }
      }
    });
  };

  const handleDeletePayment = async () => {
    const apiServe = new APIService();
    const response = await apiServe.addDataToBackend(
      { ID: paymentsModalData?.ID },
      `deletepaymentapplied`,
    );
    if (response?.status === 200 || response?.status === 201) {
      Swal.fire("Deleted!", "Payment Deleted!", "success").then(() => {
        window.location.reload();
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Delete Failed",
        text: "Please try again",
      });
    }
  };

  const handleUpdatePayments = async () => {
    // console.log("Clicked ok button");
    const postObj = {
      InvoiceID: invoiceData?.ID,
      ID: paymentsModalData?.ID,
      CheckNumber: editCheckNumber,
      AppliedTotal: editAppliedTotal,
      PaymentType: editPaymentType?.value,
    };
    console.log("Post Object Payment: ", postObj);
    let isValid = true;
    if (!editCheckNumber || editCheckNumber === "") {
      isValid = false;
    }
    if (!editAppliedTotal || editAppliedTotal === "") {
      isValid = false;
    }
    if (!editPaymentType || editPaymentType === "") {
      isValid = false;
    }
    if (!isValid) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill all the fields",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You are about to update the order",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Yes, submit it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend(
          postObj,
          "updatepaymentsapplied",
        );
        // console.log("Add Payments Response: ", response);
        setModalOpenAddPayment(false);
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Updated!", "Payment Updated!", "success").then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Update Failed",
            text: "Please try again",
          });
        }
      }
    });
  };

  const handlePaymentsOk = async () => {
    if (!canAddPayment || !canShowAddPayment) {
      return;
    }

    // console.log("Clicked ok button");
    console.log("Payment Type: ", paymentType);
    const normalizedAppliedTotal = roundToTwo(Number(appliedTotal));
    const postObj = {
      CheckNumber: checkNumber,
      AppliedTotal: normalizedAppliedTotal,
      AppliedDate: appliedDatePayment,
      InvoiceID: invoiceData?.ID,
      InvoiceNumber: invoiceData?.InvoiceNumber,
      AccountID: formattedOrders?.AccountID,
      AccountName: formattedOrders?.AccountName,
      ManufacturerID: formattedOrders?.ManufacturerID,
      ManufacturerName: formattedOrders?.ManufacturerName,
      OrderID: formattedOrders?.ID,
      PONumber: formattedOrders?.PONumber,
      OrderType: formattedOrders?.OrderType,
      PaymentType: paymentType?.value,
    };
    console.log("Post Object Payment: ", postObj);
    let isValid = true;
    if (!checkNumber || checkNumber.trim() === "") {
      isValid = false;
    }
    if (
      !Number.isFinite(normalizedAppliedTotal) ||
      normalizedAppliedTotal <= 0 ||
      normalizedAppliedTotal > normalizedOpenBalance
    ) {
      isValid = false;
    }
    if (!appliedDatePayment || appliedDatePayment === "") {
      isValid = false;
    }
    if (!paymentType || paymentType === "") {
      isValid = false;
    }
    if (!isValid) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          normalizedOpenBalance <= 0
            ? "This invoice no longer has an open balance."
            : "Please fill all the fields with valid values.",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You are about to create a payment for this invoice.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["successColor"],
      cancelButtonColor: colors["failureColor"],
      confirmButtonText: "Confirm",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const apiServe = new APIService();
          const response = await apiServe.addDataToBackend(
            postObj,
            "addpaymentsapplied",
          );
          // console.log("Add Payments Response: ", response);
          setModalOpenAddPayment(false);
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire("Added!", "New Payment Added!", "success").then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Payment Submission Failed",
              text: "Please try again",
            });
          }
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.data ||
            "Please try again";
          Swal.fire({
            icon: "error",
            title: "Payment Submission Failed",
            text: errorMessage,
          });
        }
      }
    });
  };

  const [paymentsModalData, setPaymentsModalData] = React.useState(null);

  const [checkNumber, setCheckNumber] = React.useState(null);
  const [appliedTotal, setAppliedTotal] = React.useState(null);
  const [appliedTotalError, setAppliedTotalError] = React.useState(null);
  const [appliedDate, setAppliedDate] = React.useState(null); // apply comm and apply comm in full
  const [statementMonthComm, setStatementMonthComm] = useState(null); // apply comm and apply comm in full
  const [paymentType, setPaymentType] = React.useState(null);
  const [appliedDatePayment, setAppliedDatePayment] = useState(null);

  const [tempCreditMemo, setTempCreditMemo] = React.useState("");

  const [commContractAlert, setCommContractAlert] = useState(false);
  const [commContractAlertData, setCommContractAlertData] = useState(null);
  const [isAddNoteOpen, setIsAddNoteOpen] = useState(false);
  const [isNotifyCheck, setIsNotifyCheck] = useState(false);
  const [selectedSegment, setSelectedSegment] = useState("Invoice Details");

  const {
    data: { account = {}, distributor = {} },
  } = dummyNotesData;

  const handleSegmentChange = (value) => {
    setSelectedSegment(value);
  };

  const fetchAccountDetails = async (accountID) => {
    try {
      const apiServe = new APIService();
      const accountData = await requestInvoiceAccountDetails(apiServe, accountID);
      setAccountDetails(accountData ?? undefined);
      return accountData;
    } catch (error) {
      console.error("Unable to load invoice account details", error);
      setAccountDetails(undefined);
      return null;
    } finally {
      setIsAccountDataLoading(false);
    }
  };

  const openCheckoutInSameTab = (checkoutUrl) => {
    const openedWindow = window.open(checkoutUrl, "_self");
    if (!openedWindow) {
      window.location.assign(checkoutUrl);
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const paymentStatus = searchParams.get("payment");
    const attemptId = searchParams.get("attempt_id");
    const sessionId = searchParams.get("session_id");

    if (!paymentStatus && !attemptId && !sessionId) {
      return;
    }

    if (paymentStatus === "success") {
      message.success("Payment received. Updating invoice status...");
    } else if (paymentStatus === "cancelled") {
      message.warning("Payment was cancelled. You can continue payment from this invoice.");
    }

    const syncCheckoutStatus = async () => {
      if (attemptId || sessionId) {
        const params = new URLSearchParams();
        if (attemptId) params.set("attemptId", attemptId);
        if (sessionId) params.set("sessionId", sessionId);
        params.set("forceRefresh", "true");
        try {
          const apiServe = new APIService();
          await apiServe.getDataFromBackend(
            `payments/checkout-session-status?${params.toString()}`,
          );
        } catch (error) {
          console.error("[InvoiceHome] Failed to sync checkout status", error);
        }
      }
      window.setTimeout(() => {
        window.location.replace(location.pathname);
      }, 1000);
    };

    syncCheckoutStatus();
  }, [location.pathname, location.search, navigate]);

  const handleInvoiceCheckoutResponse = (response, fallbackError) => {
    const checkoutUrl =
      response?.data?.data?.checkoutUrl || response?.data?.data?.url;
    if (!checkoutUrl) {
      throw new Error(fallbackError);
    }
    message.success("Redirecting to secure checkout...");
    openCheckoutInSameTab(checkoutUrl);
  };

  const handleCreateInvoiceCheckout = async ({
    amount,
    paymentMethodType,
    expectedOpenBalance,
  }) => {
    setIsCreatingInvoiceCheckout(true);
    try {
      const apiServe = new APIService();
      const response = await apiServe.addDataToBackend(
        {
          invoiceId: invoiceData?.ID,
          amount,
          paymentMethodType,
          expectedOpenBalance,
        },
        "payments/invoice/create-checkout-session",
      );
      handleInvoiceCheckoutResponse(
        response,
        "Checkout URL was not returned.",
      );
    } catch (error) {
      message.error(
        error?.response?.data?.error ||
          error?.message ||
          "Failed to create invoice checkout.",
      );
    } finally {
      setIsCreatingInvoiceCheckout(false);
    }
  };

  const handleContinueInvoicePayment = async (row) => {
    try {
      const invoiceId = invoiceData?.ID ?? row?.InvoiceID ?? params.id;
      const apiServe = new APIService();
      const response = await apiServe.addDataToBackend(
        {
          invoiceId,
          paymentAppliedId: row?.ID,
          attemptId: row?.StripeCheckoutAttemptID ?? row?.StripeResolvedAttemptID,
        },
        "payments/invoice/continue",
      );
      handleInvoiceCheckoutResponse(
        response,
        "Continue payment checkout URL was not returned.",
      );
    } catch (error) {
      message.error(
        error?.response?.data?.error ||
          error?.message ||
          "Failed to continue payment.",
      );
      refreshPaymentsAppliedData();
    }
  };

  const handleRetryInvoicePayment = async (row) => {
    try {
      const invoiceId = invoiceData?.ID ?? row?.InvoiceID ?? params.id;
      const apiServe = new APIService();
      const response = await apiServe.addDataToBackend(
        {
          invoiceId,
          paymentAppliedId: row?.ID,
          attemptId: row?.StripeCheckoutAttemptID ?? row?.StripeResolvedAttemptID,
        },
        "payments/invoice/retry",
      );
      handleInvoiceCheckoutResponse(
        response,
        "Retry payment checkout URL was not returned.",
      );
    } catch (error) {
      message.error(
        error?.response?.data?.error ||
          error?.message ||
          "Failed to retry payment.",
      );
      refreshPaymentsAppliedData();
    }
  };

  const getDateAppliedLimits = async () => {
    // return;
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend("GetDateAppliedLimits");
    console.log("getStatementData", response);
    const maxDate = dayjs(response?.data?.data?.MaxEndDate);
    const minDate = dayjs(response?.data?.data?.MinStartDate);
    console.log("maxDate", maxDate);
    setMaxDateApplied(maxDate);
    setMinDateApplied(minDate);
    return { maxDate, minDate };
  };

  const handleEditPayment = (row) => {
    if (isTruthyPrepaidOrder(row?.PrepaidOrder)) {
      return;
    }

    console.log(row);
    const newPaymentObj = {
      ...row,
      AppliedTotal: parseFloat(
        String(row.AppliedTotal).replace(/[^0-9.-]+/g, ""),
      ),
    };
    console.log(newPaymentObj);
    setEditCheckNumber(newPaymentObj.CheckNumber);
    setEditAppliedTotal(newPaymentObj.AppliedTotal);
    setPaymentsModalData(newPaymentObj);
    setEditPaymentType({
      value: newPaymentObj.PaymentType,
      label: newPaymentObj.PaymentType,
    });
    setModalOpenEditPayment(true);
  };

  const isAutomaticStripePayment = (row) =>
    resolvePaymentSource(row) === "invoice_stripe";

  const normalizeStatusValue = (value) =>
    String(value ?? "")
      .trim()
      .toLowerCase();

  const getStripePaymentRowState = (row) => {
    if (!isAutomaticStripePayment(row)) {
      return {
        state: "applied",
        canContinue: false,
        canRetry: false,
      };
    }

    const applicationStatus = normalizeStatusValue(
      row?.StripeApplicationStatus,
    );
    const derivedStatus = normalizeStatusValue(row?.StripeDerivedStatus);
    const derivedAction = normalizeStatusValue(row?.StripePaymentAction);
    const paymentStatus = normalizeStatusValue(row?.StripePaymentStatus);
    const sessionStatus = normalizeStatusValue(row?.StripeSessionStatus);
    const failureCode = normalizeStatusValue(row?.StripeFailureCode);
    const checkoutReusable = isTruthyPrepaidOrder(
      row?.StripeCheckoutReusable,
    );
    const auditFailed =
      applicationStatus === "failed" ||
      paymentStatus === "failed" ||
      paymentStatus === "expired" ||
      sessionStatus === "expired" ||
      failureCode === "reconciliation_failed" ||
      failureCode === "session_expired" ||
      Boolean(failureCode && applicationStatus !== "applied");

    if (isTrueValue(row?.PaymentSuccessful) || derivedStatus === "success") {
      return { state: "success", canContinue: false, canRetry: false };
    }

    if (
      isFalseValue(row?.PaymentSuccessful) ||
      derivedStatus === "failed" ||
      derivedAction === "retry" ||
      auditFailed
    ) {
      return { state: "failed", canContinue: false, canRetry: true };
    }

    return {
      state: "pending",
      canContinue: derivedAction === "continue" || checkoutReusable,
      canRetry: false,
    };
  };

  const getPaymentStatusLabel = (row) => {
    if (row?.PaymentDisplayStatus) {
      return row.PaymentDisplayStatus;
    }
    if (row?.StripeDerivedStatusLabel) {
      return row.StripeDerivedStatusLabel;
    }
    const { state } = getStripePaymentRowState(row);
    if (state === "success") return "Payment Successful";
    if (state === "failed") return "Payment Failed";
    if (state === "pending") return "Payment Pending";
    return "Applied";
  };

  const handleAppliedTotal = (val) => {
    console.log("Applied Total Value: ", val);
    if (val === "" || val === null || val === undefined) {
      setAppliedTotal(null);
      setAppliedTotalError(null);
      return;
    }

    const parsedAmount = Number(val);
    if (!Number.isFinite(parsedAmount) || parsedAmount <= 0) {
      setAppliedTotal(val);
      setAppliedTotalError("Payment amount must be greater than 0.");
      return;
    }

    const roundedAmount = roundToTwo(parsedAmount);
    if (roundedAmount <= normalizedOpenBalance) {
      setAppliedTotal(val);
      setAppliedTotalError(null);
    } else {
      setAppliedTotal(val);
      setAppliedTotalError(
        "Payment amount cannot be greater than open balance.",
      );
    }
  };

  const tableHeadersPaymentsAppliedInvoice = [
    {
      headerName: "Check Number",
      field: "CheckNumber",
      filter: true,
    },
    {
      headerName: "Applied Date",
      field: "AppliedDate",
      filter: true,
    },
    {
      headerName: "Payment Applied",
      field: "PaymentAppliedDisplayTotal",
      filter: true,
      cellDataType: "number",
      valueGetter: (params) =>
        parseFloat(
          String(params.data.PaymentAppliedDisplayTotal).replace(
            /[^0-9.-]+/g,
            "",
          ),
        ),
      cellRenderer: (params) => {
        const value = parseFloat(
          String(params.data.PaymentAppliedDisplayTotal).replace(
            /[^0-9.-]+/g,
            "",
          ),
        );
        return formatCurrency(value);
      },
    },
    {
      headerName: "Payment Type",
      field: "PaymentType",
      filter: true,
    },
    {
      headerName: "Status",
      field: "PaymentSuccessful",
      filter: true,
      cellRenderer: (params) => {
        const label = getPaymentStatusLabel(params?.data);
        const color =
          label === "Payment Failed"
            ? colors["failureColor"]
            : label === "Payment Pending" || label === "Bank Transfer Pending"
              ? colors["warningColor"]
              : colors["successColor"];
        return <span style={{ color, fontWeight: 500 }}>{label}</span>;
      },
    },
    {
      headerName: "Options",
      field: "",
      cellRenderer: (params) => {
        if (isAutomaticStripePayment(params?.data)) {
          const stripeRowState = getStripePaymentRowState(params?.data);
          if (stripeRowState.canRetry) {
            return (
              <TableOptionsCell
                optionOne="Retry Payment"
                optionOneType="failure"
                rowData={params.data}
                optionOneClickFn={() => handleRetryInvoicePayment(params.data)}
              />
            );
          }
          if (stripeRowState.canContinue) {
            return (
              <TableOptionsCell
                optionOne="Continue Payment"
                optionOneType="failure"
                rowData={params.data}
                optionOneClickFn={() => handleContinueInvoicePayment(params.data)}
              />
            );
          }
          return null;
        }

        if (isTruthyPrepaidOrder(params?.data?.PrepaidOrder)) {
          return null;
        }

        console.log(
          parseFloat(
            String(params.data.AppliedTotal).replace(/[^0-9.-]+/g, ""),
          ),
        );
        const canEditPayment = hasPermission(userData, "payment.edit");
        return (
          <TableOptionsCell
            optionOne={canEditPayment ? "Edit" : undefined}
            optionOneType={canEditPayment ? "warning" : undefined}
            rowData={params.data}
            optionOneClickFn={canEditPayment ? () => handleEditPayment(params.data) : undefined}
          />
        );
      },
    },
  ];

  // // remove "Options" header if not admin
  // const filteredTableHeadersPaymentsAppliedInvoice =
  //   tableHeadersPaymentsAppliedInvoice.filter((header) => {
  //     if (header.headerName === "Options") {
  //       return userData.Type === "Admin" && userData.IsSuperAdmin && !invoiceData.IsCommissionApplied;
  //     }
  //     return true;
  //   });

  // this function is to get the commission data that has already been applied.
  const getDataComm = async () => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `getinvoicecommission?InvoiceID=${invoiceData?.ID}`,
    );
    // if(response && response.data.data?.error && response.data.data?.distributorCommissionPercentage === 0){
    //   // setCheckDistPercentageZero(true);
    //   setCommContractAlert(true);
    // }
    // else if (response?.status === 200 && response?.data?.data) {
    if (response?.status === 201 && response?.data?.error) {
      setCommContractAlert(true);
      setCommContractAlertData(response?.data?.data);
    }
    if (response?.status === 200 && response?.data?.data) {
      setIsInvoiceCommissionLoading(false);
      setCommContractAlert(false);
      setInvoiceCommissionData(response?.data?.data);
    }
  };

  const currentDate = dayjs();
  const invoiceProductsForCollections = useMemo(
    () => invoiceHomeData?.invoiceProducts ?? [],
    [invoiceHomeData?.invoiceProducts],
  );
  const hasSentToCollection =
    isTrueValue(invoiceData?.HasSentToCollection) ||
    invoiceProductsForCollections.some((product) =>
      isTrueValue(product?.IsSentToCollection),
    );

  const getCollectionIneligibilityReason = (product) => {
    if (product?.IsSentToCollection) return "Already sent to collections";
    if (product?.IsReturned || product?.ReturnCompleted) return "Returned";
    if (product?.ReturnStarted) return "Return in progress";
    if (product?.HasCommissionApplied) return "Commission already applied";
    return "";
  };

  const collectionProducts = useMemo(
    () =>
      invoiceProductsForCollections.map((product) => ({
        ...product,
        collectionDisabledReason: getCollectionIneligibilityReason(product),
      })),
    [invoiceProductsForCollections],
  );

  const eligibleCollectionProductIds = useMemo(
    () =>
      collectionProducts
        .filter((product) => !product.collectionDisabledReason)
        .map((product) => product.ID),
    [collectionProducts],
  );

  const allEligibleCollectionProductsSelected =
    eligibleCollectionProductIds.length > 0 &&
    eligibleCollectionProductIds.every((productId) =>
      selectedCollectionProductIds.includes(productId),
    );
  const contractRightsExercised = isTrueValue(
    invoiceData?.ContractRightsExercised,
  );
  const canExerciseContractRights =
    hasPermission(userData, "commission.exercise_contract_rights") &&
    invoiceData &&
    !isTrueValue(invoiceData?.IsVoided) &&
    !contractRightsExercised &&
    !isTrueValue(invoiceData?.IsCommissionFullyApplied);
  const canAccessInvoiceCommissions = [
    "commission.apply",
    "commission.reset",
    "commission.exercise_contract_rights",
  ].some((permission) => hasPermission(userData, permission));
  const commissionBlockedByFullyApplied = isTrueValue(
    invoiceData?.IsCommissionFullyApplied,
  );

  const totalPaymentsApplied = roundToTwo(
    invoiceData?.TotalPaymentsApplied ?? 0,
  );
  const invoiceTotal = roundToTwo(invoiceData?.InvoiceTotal ?? 0);
  const shippingCost = roundToTwo(invoiceData?.ShippingCost ?? 0);
  const cardProcessingFee = roundToTwo(invoiceData?.CardProcessingFee ?? 0);
  const bankProcessingFee = roundToTwo(invoiceData?.BankProcessingFee ?? 0);
  const includedProcessingFees = [
    cardProcessingFee > 0
      ? { label: "Card Processing Fee", amount: cardProcessingFee }
      : null,
    bankProcessingFee > 0
      ? { label: "Bank Processing Fee", amount: bankProcessingFee }
      : null,
  ].filter(Boolean);
  const invoiceTotalWithCharges = roundToTwo(
    invoiceTotal + shippingCost + cardProcessingFee + bankProcessingFee,
  );
  const collectionProductSubtotal = useMemo(
    () =>
      roundToTwo(
        invoiceProductsForCollections.reduce((total, product) => {
          if (!isTrueValue(product?.IsSentToCollection)) return total;
          return total + roundToTwo(product?.Price ?? 0);
        }, 0),
      ),
    [invoiceProductsForCollections],
  );
  const sentToCollectionTotal = roundToTwo(
    collectionProductSubtotal +
      shippingCost +
      cardProcessingFee +
      bankProcessingFee,
  );
  const sentToCollectionBreakdown = [
    shippingCost > 0 ? { label: "Shipping Cost", amount: shippingCost } : null,
    ...includedProcessingFees,
  ].filter(Boolean);
  const displayInvoiceTotal = hasSentToCollection
    ? invoiceTotal
    : invoiceTotalWithCharges;
  const normalizedOpenBalance = roundToTwo(
    Math.max(displayInvoiceTotal - totalPaymentsApplied, 0),
  );
  const canShowAddPayment =
    Boolean(invoiceData) &&
    !Boolean(invoiceData?.IsVoided) &&
    !Boolean(invoiceData?.IsCommissionFullyApplied) &&
    !isTruthyPrepaidOrder(invoiceData?.PrepaidOrder) &&
    normalizedOpenBalance > 0;

  // Status is derived live, in the same precedence the backend uses:
  // Voided > Sent To Collection > Fully Paid > Past Due > Open Balance.
  const statusIndicatorText = Boolean(invoiceData?.IsVoided)
    ? { text: "Voided", type: "voided" }
    : hasSentToCollection
      ? { text: "Sent To Collection", type: "primary" }
      : totalPaymentsApplied >= displayInvoiceTotal
        ? { text: "Fully Paid", type: "success" }
        : invoiceData?.InvoiceDueDate &&
            dayjs(invoiceData.InvoiceDueDate).startOf("day").isBefore(dayjs().startOf("day"))
          ? { text: "Past Due", type: "failure" }
          : { text: "Open Balance", type: "warning" };

  const canShowMakePayment =
    Boolean(invoiceData) &&
    isTruthyPrepaidOrder(invoiceData?.CollectPayment) &&
    !Boolean(invoiceData?.IsVoided) &&
    normalizedOpenBalance > 0 &&
    (statusIndicatorText.type === "warning" ||
      statusIndicatorText.type === "failure");

  const value =
    displayInvoiceTotal > 0
      ? (totalPaymentsApplied / displayInvoiceTotal) * 100
      : 0;

  const diffInDays = dayjs(invoiceData?.InvoiceDueDate).diff(
    currentDate,
    "day",
  );

  const diffInDaysPastDue = currentDate.diff(
    dayjs(invoiceData?.InvoiceDueDate),
    "day",
  );

  const orderLinkToPath = useMemo(() => {
    if (invoiceData?.OrderType === "Direct Order") {
      return `/DirectOrder/${invoiceData?.OrderID}`;
    } else if (invoiceData?.OrderType === "Consignment Order") {
      return `/ConsignmentOrder/${invoiceData?.OrderID}`;
    } else if (invoiceData?.OrderType === "Product Usage") {
      return `/ProductUsage/${invoiceData?.OrderID}`;
    } else {
      return ``;
    }
  });

  const getStatementData = async (dateApp) => {
    const apiServe = new APIService();
    const response = await apiServe.getDataFromBackend(
      `GetStatementDataForDateApplied?DateApplied=${dateApp}`,
    );

    return response?.data?.data;
  };

  const [maxDateApplied, setMaxDateApplied] = useState(null);
  const [minDateApplied, setMinDateApplied] = useState(null);
  // const [statementMonth, setStatementMonth] = useState(null);

  const handleAppliedDateChange = async (date) => {
    setAppliedDate(date);

    const statementData = await getStatementData(date);

    if (statementData) {
      setStatementMonthComm(statementData?.StatementMonthYear);
    } else {
      setStatementMonthComm("NA");
    }
  };

  // const [distCommPayable, distCommPayableDecimal] = formatNumber(
  //   invoiceCommissionData?.TotalCommissionPayableDistributor
  // ).split(".");

  const [distCommDue, distCommDueDecimal] = formatNumber(
    invoiceCommissionData?.CommissionDueDistributor,
  ).split(".");

  const [commReceivable, commReceivableDecimal] = formatNumber(
    Number(distCommPayableTotal) -
      Number(invoiceCommissionData?.DistributorCommissionPaid),
  ).split(".");

  const lastEdited = moment(invoiceData?.updatedAt).format("MMMM D, YYYY");

  const handleApplyCommModal = () => {
    setModalOpenApplyComm(false);
  };

  const [uploadInvoice, setUploadInvoice] = React.useState(null);
  const [uploadFileList, setUploadFileList] = React.useState([]);
  const [isFileUpdated, setIsFileUpdated] = React.useState(false);
  const [fileName, setFileName] = React.useState(null);
  const [uploadInvoiceFileBlobName, setUploadInvoiceFileBlobName] =
    React.useState(null);

  const handleFile = async ({ file, onSuccess }) => {
    if (file.size > 4194304) {
      message.error("File size should be less than 4MB");
      setFileName(null);
      setUploadInvoice(null);
      setUploadFileList([]);
      return;
    }
    setIsFileUpdated(true);
    setUploadFileList([{ name: file.name, status: "done", uid: "1" }]);
    setUploadInvoice(file);
    setFileName(file.name);
    setTimeout(() => {
      onSuccess("ok");
    }, 0);
  };

  const getInvoiceFilesHistory = async () => {
    setIsInvoiceFilesLoading(true);
    setInvoiceFilesError("");
    try {
      const apiServe = new APIService();
      const response = await apiServe.getDataFromBackend(
        `getinvoicefiles?InvoiceID=${params.id}`,
      );
      const files = Array.isArray(response?.data?.data) ? response.data.data : [];
      setInvoiceFilesHistory(files);
    } catch (error) {
      setInvoiceFilesError("Unable to load invoice files right now.");
      setInvoiceFilesHistory([]);
    } finally {
      setIsInvoiceFilesLoading(false);
    }
  };

  const handleOpenInvoiceFilesModal = async () => {
    setIsInvoiceFilesModalOpen(true);
    await getInvoiceFilesHistory();
  };

  const invoiceFilesModalRows = useMemo(
    () =>
      invoiceFilesHistory.map((file) => ({
        ...file,
        UpdatedOnLabel: moment(file.UpdatedOn || file.CreatedOn).format(
          "MM-DD-YYYY",
        ),
      })),
    [invoiceFilesHistory],
  );

  const invoiceFilesModalColumns = useMemo(
    () => [
      {
        headerName: "File Name",
        field: "FileName",
        filter: true,
        minWidth: 320,
        cellRenderer: (params) => (
          <div className="invoice-files-modal-name-cell">
            <Text variant="bodyText">{params.data?.FileName}</Text>
            {params.data?.IsLatest ? (
              <Tags
                textColor="successColorDark"
                tagBackground="successColorLight"
                tagText="Latest"
              />
            ) : null}
          </div>
        ),
      },
      {
        headerName: "Updated On",
        field: "UpdatedOnLabel",
        filter: true,
        minWidth: 180,
      },
      {
        headerName: "Options",
        field: "options",
        sortable: false,
        filter: false,
        minWidth: 180,
        cellRenderer: (params) => (
          <CommonButton
            variant="table"
            subVariant="primary"
            onClick={() => downloadInvoiceHistoryFile(params.data)}
          >
            Download
          </CommonButton>
        ),
      },
    ],
    [],
  );

  async function downloadInvoiceHistoryFile(file) {
    if (!file?.BlobName) {
      message.error("File does not exist.");
      return;
    }

    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(file.BlobName);
    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }

    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = file.FileName || "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const downloadFile = async () => {
    const apiServe = new APIService();
    const sasUrl = await apiServe.getSasToken(uploadInvoiceFileBlobName);

    const exists = await apiServe.checkBlobExists(sasUrl);
    if (!exists) {
      message.error("File does not exist.");
      return;
    }
    // download the file from Azure Blob Storage
    const link = document.createElement("a");
    link.href = sasUrl;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    // action: 'https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload',
    accept: [".pdf"],
    // disabled: !isEditable,
    fileList: uploadFileList,
    customRequest: handleFile,
    onPreview: downloadFile,
    onRemove: () => {
      if (!uploadInvoice && uploadInvoiceFileBlobName) {
        return false;
      }
      setUploadInvoice(null);
      if (invoiceData?.UploadInvoiceFileName) {
        setUploadFileList([
          {
            name: invoiceData.UploadInvoiceFileName,
            status: "done",
            uid: "1",
          },
        ]);
        setFileName(invoiceData.UploadInvoiceFileName);
      } else {
        setUploadFileList([]);
        setFileName(null);
      }
      setIsFileUpdated(true);
      return true;
    },
    onChange(info) {
      console.log("File Info: ", info);
      const { status } = info.file;
      // console.log("Status: ", status);
      if (status !== "uploading") {
        // console.log(info.file, info.fileList);
      }
      if (status === "done") {
        // setIvrReport(info.file.originFileObj);
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files);
    },
  };

  const handleShowViewProduct = () => {
    setShowViewProduct(!showViewProduct);
  };

  const resetCommissionRows = useMemo(() => {
    const products = invoiceCommissionData?.CommissionBreakdownNew ?? [];
    return products.flatMap((product) =>
      (product?.Commissions ?? []).map((commission) => ({
        ...commission,
        InvoiceProductID:
          commission?.InvoiceProductID ?? product?.InvoiceProductID,
        TissueID: commission?.TissueID ?? product?.TissueID,
        ProductCode: commission?.ProductCode ?? product?.ProductCode,
        ProductGroupName:
          commission?.ProductGroupName ?? product?.ProductGroupName,
      })),
    );
  }, [invoiceCommissionData?.CommissionBreakdownNew]);

  const resetCommission = () => {
    if (!resetCommissionRows.length) {
      Swal.fire({
        icon: "warning",
        title: "No Commissions Found",
        text: "There are no commission rows available to reset for this invoice.",
      });
      return;
    }
    setModalOpenResetCommission(true);
  };

  const handleResetCommissionRow = React.useCallback((rowData) => {
    if (!rowData?.CommissionID) {
      Swal.fire({
        icon: "error",
        title: "Missing Commission",
        text: "Unable to reset commission because the commission row is missing.",
      });
      return;
    }

    if (!rowData?.CanResetCommission) {
      Swal.fire({
        icon: "warning",
        title: "Commission Reset Not Allowed",
        text:
          rowData?.ResetBlockedReason ||
          "This commission cannot be reset.",
      });
      return;
    }

    Swal.fire({
      title: "Reset this commission?",
      text: "This will remove only the selected commission row. Payments and generated statements will not be changed.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["failureColor"],
      cancelButtonColor: colors["lightText"],
      confirmButtonText: "Reset Commission",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;
      try {
        const apiServe = new APIService();
        const response = await apiServe.addDataToBackend(
          {
            CommissionID: rowData.CommissionID,
            InvoiceID: invoiceData?.ID,
          },
          `resetcommission`,
        );
        if (response?.status === 200 || response?.status === 201) {
          Swal.fire("Reset!", "Commission Reset!", "success").then(() => {
            window.location.reload();
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Commission Reset Failed",
            text: response?.data?.message || "Please try again.",
          });
        }
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Commission Reset Failed",
          text: error?.response?.data?.message || "Please try again.",
        });
      }
    });
  }, [invoiceData?.ID]);

  const resetCommissionColumns = useMemo(
    () => [
      {
        headerName: "Date Applied",
        field: "DateApplied",
        filter: true,
        minWidth: 150,
        cellRenderer: (params) =>
          params.data?.DateApplied
            ? moment(params.data.DateApplied).format("MM-DD-YYYY")
            : "",
      },
      {
        headerName: "Tissue ID",
        field: "TissueID",
        filter: true,
        minWidth: 140,
      },
      {
        headerName: "Product Code",
        field: "ProductCode",
        filter: true,
        minWidth: 150,
      },
      {
        headerName: "Amount Applied",
        field: "Received",
        filter: true,
        cellDataType: "number",
        minWidth: 160,
        cellRenderer: (params) =>
          formatCurrency(params.data?.Received ?? 0),
      },
      {
        headerName: "Reset Status",
        field: "ResetBlockedReason",
        filter: true,
        minWidth: 260,
        cellRenderer: (params) =>
          params.data?.CanResetCommission
            ? "Available"
            : params.data?.ResetBlockedReason || "Blocked",
      },
      {
        headerName: "Options",
        field: "",
        sortable: false,
        minWidth: 190,
        cellRenderer: (params) => (
          <TableOptionsCell
            optionOne={params.data?.CanResetCommission ? "Reset" : ""}
            optionOneType="failure"
            optionOneClickFn={
              params.data?.CanResetCommission
                ? handleResetCommissionRow
                : undefined
            }
            rowData={params.data}
          />
        ),
      },
    ],
    [handleResetCommissionRow],
  );

  const exerciseContractRights = () => {
    Swal.fire({
      title: "Exercise Contract Rights?",
      text: "This will move the invoice and associated order to the House Distributor and remove assigned distributor users. Existing applied commissions will not be changed. Future commission application will use the House Distributor.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["warningColor"],
      cancelButtonColor: colors["lightText"],
      confirmButtonText: "Exercise Rights",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const apiServe = new APIService();
          const response = await apiServe.addDataToBackend(
            {
              InvoiceID: invoiceData?.ID,
            },
            "exercisecontractrights",
          );

          if (response?.status === 200 || response?.status === 201) {
            Swal.fire(
              "Contract Rights Exercised",
              "The invoice and associated order were moved to the House Distributor.",
              "success",
            ).then(() => {
              window.location.reload();
            });
          } else {
            Swal.fire({
              icon: "error",
              title: "Contract Rights Exercise Failed",
              text: "Please try again",
            });
          }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Contract Rights Exercise Failed",
            text:
              error?.response?.data?.message ||
              "Unable to exercise contract rights. Please try again.",
          });
        }
      }
    });
  };

  const resetPayments = () => {
    if (!canResetPayments(userData)) return;
    console.log("Reset Payments");
    if (invoiceData?.PrepaidOrder) {
      Swal.fire({
        icon: "error",
        title: "Payments Reset Not Allowed",
        text: "Payments cannot be reset for prepaid invoices.",
      });
      return;
    }

    Swal.fire({
      title: "Reset Payments?",
      text: "Are you sure you want to reset all payments applied to this invoice. This will delete all payments made to this invoice, and set the Total Payments Applied to $0. You cannot undo this.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: colors["failureColor"],
      cancelButtonColor: colors["lightText"],
      confirmButtonText: "Yes, reset it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const apiServe = new APIService();
          const response = await apiServe.addDataToBackend(
            {
              InvoiceID: invoiceData?.ID,
            },
            `resetpayments`,
          );
          if (response?.status === 200 || response?.status === 201) {
            Swal.fire("Reset!", "Payments Reset!", "success").then(() => {
              window.location.reload();
            });
            return;
          }

          Swal.fire({
            icon: "error",
            title: "Payments Reset Failed",
            text: "Please try again",
          });
        } catch (error) {
          const errorMessage =
            error?.response?.data?.message ||
            error?.response?.data?.data ||
            "Please try again";
          Swal.fire({
            icon: "error",
            title: "Payments Reset Failed",
            text: errorMessage,
          });
        }
      }
    });
  };

  useEffect(() => {
    if (modalOpenCollections) {
      setSelectedCollectionProductIds(eligibleCollectionProductIds);
      return;
    }
    setSelectedCollectionProductIds([]);
  }, [modalOpenCollections, eligibleCollectionProductIds]);

  const toggleCollectionProduct = (productId) => {
    setSelectedCollectionProductIds((current) =>
      current.includes(productId)
        ? current.filter((id) => id !== productId)
        : [...current, productId],
    );
  };

  const toggleAllEligibleCollectionProducts = () => {
    setSelectedCollectionProductIds(
      allEligibleCollectionProductsSelected ? [] : eligibleCollectionProductIds,
    );
  };

  const submitSendToCollections = async () => {
    if (selectedCollectionProductIds.length === 0) {
      Swal.fire({
        icon: "error",
        title: "No products selected",
        text: "Select at least one eligible product to send to collections.",
      });
      return;
    }

    setIsSendingToCollections(true);
    try {
      const apiServe = new APIService();
      const response = await apiServe.addDataToBackend(
        {
          InvoiceID: invoiceData?.ID,
          InvoiceProductIDs: selectedCollectionProductIds,
          ApplyToEntireInvoice:
            selectedCollectionProductIds.length ===
              eligibleCollectionProductIds.length &&
            eligibleCollectionProductIds.length > 0,
        },
        `sendinvoiceproductstocollections`,
      );

      if (response?.status === 200 || response?.status === 201) {
        Swal.fire(
          "Updated!",
          "Selected products were sent to collections.",
          "success",
        ).then(() => {
          window.location.reload();
        });
        return;
      }

      Swal.fire({
        icon: "error",
        title: "Collections update failed",
        text:
          response?.data?.message ||
          response?.data?.error ||
          "Please try again.",
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Collections update failed",
        text: "Please try again.",
      });
    } finally {
      setIsSendingToCollections(false);
    }
  };

  const hasNoteContent = (note) => {
    if (!note) return false;
    if (Array.isArray(note)) {
      return note.some((entry) => hasNoteContent(entry));
    }
    const content =
      note?.Note ?? note?.note ?? note?.NoteContent ?? note?.NoteText ?? "";
    if (typeof content === "string") {
      return content.trim().length > 0;
    }
    return Boolean(content);
  };

  const hasAccountNote = useMemo(
    () => hasNoteContent(invoiceNotesAccount),
    [invoiceNotesAccount],
  );
  const hasDistributorNote = useMemo(
    () => hasNoteContent(invoiceNotesDistributor),
    [invoiceNotesDistributor],
  );
  // Add Note button is shown to admins (auth context) — same source/role as the
  // note edit/delete actions in NotesSection. Not gated on free note slots.
  const canShowAddNote =
    userData?.Type === "Admin" && !(hasAccountNote && hasDistributorNote);

  const noteOptions = useMemo(() => {
    const options = [];
    if (!hasAccountNote) {
      options.push({ label: "Account", value: "account-note" });
    }
    if (!hasDistributorNote) {
      options.push({ label: "Distributor", value: "distributor-note" });
    }
    return options;
  }, [hasAccountNote, hasDistributorNote]);


  useEffect(() => {
    if (noteOptions.length === 1) {
      setIsNoteTypeSelected(noteOptions[0]);
      return;
    }
    if (
      noteOptions.length === 0 ||
      !noteOptions.some((option) => option.value === isNoteTypeSelected?.value)
    ) {
      setIsNoteTypeSelected(null);
    }
  }, [noteOptions, isNoteTypeSelected]);

  const [noteContent, setNoteContent] = useState("");

  const addNote = async () => {
    console.log("Note Type: ", isNoteTypeSelected?.value);
    console.log("Note Content: ", noteContent);
    console.log("isNotifyCheck: ", isNotifyCheck);
    if (noteOptions.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Note already exists",
        text: "Both Account and Distributor notes already exist for this invoice.",
      });
      return;
    }
    if (!isNoteTypeSelected || !noteContent) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please select note type and enter note content",
      });
      return;
    }
    const apiServe = new APIService();
    const response = await apiServe.addDataToBackend(
      {
        NoteType: isNoteTypeSelected.label,
        NoteContent: noteContent,
        InvoiceID: invoiceData?.ID,
        NotifyByEmail: isNotifyCheck,
        AccountID:
          isNoteTypeSelected.value === "account-note"
            ? invoiceData.AccountID
            : null,
        DistributorID:
          isNoteTypeSelected.value === "distributor-note"
            ? invoiceData.DistributorID
            : null,
      },
      `addinvoicenote`,
    );
    console.log("Add Note Response: ", response);
    if (response?.status === 200 || response?.status === 201) {
      Swal.fire("Added!", "Note Added!", "success")
        .then(() => {
          setIsAddNoteOpen(false);
          setIsNotifyCheck(false);
          setIsNoteTypeSelected(null);
          setNoteContent("");
        })
        .then(() => {
          window.location.reload();
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Note Addition Failed",
        text: "Please try again",
      });
    }
  };

  // Add Payment is omitted unless the caller has AS-user access. Once allowed,
  // invoice-state restrictions keep the action visible but disabled.
  const isVoidedInvoice = isTrueValue(invoiceData?.IsVoided);
  const commissionApplied = isTrueValue(invoiceData?.IsCommissionApplied);

  const adminActionSections = [
    {
      heading: "General",
      items: [
        {
          label: "Edit",
          subVariant: "warning",
          onClick: () => setModalOpenEdit(true),
          disabled: !hasPermission(userData, "invoice.edit"),
          disabledReason: "You do not have permission to edit this invoice",
        },
        ...(canAddPayment
          ? [
              {
                label: "Add Payment",
                subVariant: "warning",
                onClick: () => setModalOpenAddPayment(true),
                disabled: !canShowAddPayment,
                disabledReason:
                  "This invoice cannot take a payment right now",
              },
            ]
          : []),
      ],
    },
    {
      heading: "Commissions",
      items: [
        {
          label: "Apply Commission",
          subVariant: "success",
          onClick: () => setModalOpenApplyComm(true),
          disabled:
            !hasPermission(userData, "commission.apply") ||
            isVoidedInvoice ||
            commissionBlockedByFullyApplied ||
            applyCommissionDisable,
          disabledReason: !hasPermission(userData, "commission.apply")
            ? "You do not have permission to apply commission"
            : "Commission cannot be applied to this invoice",
        },
        {
          label: "Apply Commission In Full",
          subVariant: "success",
          onClick: async () => {
            setModalOpenApplyCommFull(true);
            await getDateAppliedLimits();
          },
          disabled:
            !hasPermission(userData, "commission.apply") ||
            isVoidedInvoice ||
            commissionBlockedByFullyApplied ||
            applyCommissionDisable,
          disabledReason: !hasPermission(userData, "commission.apply")
            ? "You do not have permission to apply commission"
            : "Commission cannot be applied to this invoice",
        },
      ],
    },
    {
      heading: "Danger Zone",
      items: [
        ...(canResetPayments(userData)
          ? [{
              label: "Reset Payments",
              subVariant: "failure",
              onClick: resetPayments,
              disabled:
                isTruthyPrepaidOrder(invoiceData?.PrepaidOrder) ||
                commissionApplied ||
                isVoidedInvoice,
              disabledReason: "Payments cannot be reset on this invoice",
            }]
          : []),
        {
          label: "Reset Commission",
          subVariant: "failure",
          onClick: resetCommission,
          disabled:
            !hasPermission(userData, "commission.reset") ||
            !commissionApplied ||
            isTrueValue(invoiceData?.IsStatementGenerated) ||
            isVoidedInvoice,
          disabledReason: !hasPermission(userData, "commission.reset")
            ? "You do not have permission to reset commission"
            : "Commission cannot be reset on this invoice",
        },
        {
          label: "Exercise Contract Rights",
          subVariant: "failure",
          onClick: exerciseContractRights,
          disabled: !canExerciseContractRights,
          disabledReason: !hasPermission(
            userData,
            "commission.exercise_contract_rights",
          )
            ? "You do not have permission to exercise contract rights"
            : "Contract rights cannot be exercised on this invoice",
        },
        {
          label: "Send To Collections",
          subVariant: "failure",
          onClick: () => setModalOpenCollections(true),
          disabled:
            !hasPermission(userData, "invoice.send_to_collections") ||
            isVoidedInvoice ||
            hasSentToCollection,
          disabledReason: !hasPermission(userData, "invoice.send_to_collections")
            ? "You do not have permission to send invoices to collections"
            : "This invoice cannot be sent to collections",
        },
        {
          label: "Void",
          subVariant: "failure",
          onClick: () => setModalOpenVoid(true),
          disabled: !hasPermission(userData, "invoice.void") || isVoidedInvoice,
          disabledReason: !hasPermission(userData, "invoice.void")
            ? "You do not have permission to void this invoice"
            : "This invoice is already voided",
        },
      ],
    },
  ];


  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "32px" }}>
      {isInvoiceDataLoading &&
        isInvoiceCommissionLoading &&
        isAccountDataLoading &&
        isOrderDetailsLoading && (
          <Flex align="center" gap="middle">
            <Spin
              indicator={
                <LoadingOutlined
                  style={{
                    fontSize: 48,
                  }}
                  spin
                />
              }
              fullscreen
            />
          </Flex>
        )}
      <TitleBar
        entityName={invoiceData?.AccountName}
        label={
          invoiceType !== "Consignment Order"
            ? "Invoice"
            : `Consignment Order ${invoiceData?.PONumber}`
        }
        invoiceNumber={invoiceData?.InvoiceNumber}
        statusIndicatorStatus={
          invoiceData?.IsVoided ? "Voided" : statusIndicatorText.text
        }
        statusIndicatorStatusType={
          invoiceData?.IsVoided ? "voided" : statusIndicatorText.type
        }
        headerBottomExtra={
          contractRightsExercised && (
            <Tags
              textColor="warningColor"
              tagBackground="warningColorLight"
              tagText="Contract Rights Exercised"
            />
          )
        }
        filterBarComponents={
          <>
            <CommonButton
              isActive={selectedSegment === "Invoice Details"}
              variant="timeframe"
              onClick={() => handleSegmentChange("Invoice Details")}
            >
              Invoice Details
            </CommonButton>
            {(userData.Type === "Admin" ||
              userData.Type === "ASD" ||
              userData.Type === "Authorizer" ||
              userData.Type === "Viewer") &&
              canAccessInvoiceCommissions && (
                <CommonButton
                  isActive={selectedSegment === "Invoice Commissions"}
                  variant="timeframe"
                  onClick={() => handleSegmentChange("Invoice Commissions")}
                >
                  Invoice Commissions
                </CommonButton>
              )}
          </>
        }
        rightFilterBarComponents={
          userData.Type === "Admin" && invoiceData ? (
            <TableOptionsCellMenu
              actionOption="Admin Actions"
              actionOptionType="primary"
              align="right"
              sections={adminActionSections}
            />
          ) : null
        }
      />
      <TabFade activeKey={selectedSegment}>
      {selectedSegment === "Invoice Details" && (
        <>
          <DetailsContainer
            style={{ marginBottom: "32px" }}
            showRightThirdSection={false}
            metadata={{ label: "QBO Invoice ID", value: invoiceData?.QBOInvoiceID || "—" }}
            accountName={invoiceData?.AccountName}
            accountID={invoiceData?.AccountID}
            isChild={accountDetails?.IsChildAccount}
            distributorName={invoiceData?.DistributorName}
            distributorID={invoiceData?.DistributorID}
            manufacturerName={invoiceData?.ManufacturerName}
            manufacturerID={invoiceData?.ManufacturerID}
            downloadInvoiceFileName={invoiceData?.UploadInvoiceFileName}
            downloadInvoiceFileBlobName={invoiceData?.UploadInvoiceFileBlobName}
            onViewAllInvoiceFiles={handleOpenInvoiceFilesModal}
            showInvoiceFilesLink={Boolean(
              invoiceData?.UploadInvoiceFileName,
            )}
            invoiceDate={moment(invoiceData?.InvoiceDate).format("MM-DD-YYYY")}
            invoiceDue={moment(invoiceData?.InvoiceDueDate).format(
              "MM-DD-YYYY",
            )}
            rightFirstHeading="Invoice Date"
            rightSecondHeading="Due On"
            manufacturerNameOnly={
              !(
                userData.Type === "Admin" ||
                userData.Type === "ASD" ||
                userData.Type === "Authorizer" ||
                userData.Type === "Viewer"
              )
            }
          />
          <div
            className={
              isPhone
                ? `invoice-page-column-layout-parent-container-phone`
                : `invoice-page-column-layout-parent-container`
            }
          >
            <div className="column-layout-division-container">
              <ProgressContainer
                invoiceTotal={displayInvoiceTotal}
                shippingCost={shippingCost}
                processingFees={includedProcessingFees}
                sentToCollectionTotal={
                  hasSentToCollection ? sentToCollectionTotal : null
                }
                sentToCollectionBreakdown={
                  hasSentToCollection ? sentToCollectionBreakdown : []
                }
                totalPaymentsApplied={totalPaymentsApplied}
                openBalance={
                  (hasSentToCollection ||
                    statusIndicatorText.type === "warning") &&
                  normalizedOpenBalance
                }
                pastDue={
                  statusIndicatorText.type === "failure" &&
                  normalizedOpenBalance
                }
                fullyPaid={
                  invoiceData?.FullyPaidDate &&
                  moment(invoiceData?.FullyPaidDate).format("MM-DD-YYYY")
                }
                progressBarWidth={value}
                openBalanceDays={diffInDays}
                pastDueDays={diffInDaysPastDue}
                actionComponent={
                  canShowMakePayment ? (
                    <CommonButton
                      variant="table"
                      subVariant="success"
                      onClick={() => setModalOpenMakePayment(true)}
                    >
                      Make Payment
                    </CommonButton>
                  ) : null
                }
              />
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "32px",
                  alignSelf: "stretch",
                  flexDirection: isPhone ? "column" : "row",
                }}
              >
                {orderProducts && (
                  <ProductListModule
                    items={orderProducts}
                    listTitle="Products"
                    primaryTitle="TissueID"
                    secondaryTitle="ProductCode"
                    price="Price"
                    showViewProduct={showViewProduct}
                    handleShowViewProduct={handleShowViewProduct}
                    invoiceData={invoiceData}
                    invoiceTotal={Number(invoiceData?.InvoiceTotal)}
                    // shippingCost={Number(invoiceData?.ShippingCost)}
                  />
                )}
                <DetailWrapper
                  poNumber={invoiceData?.PONumber ?? ""}
                  orderStatus={formattedOrders?.Status?.props?.children ?? ""}
                  orderStatusType={formattedOrders?.Status?.props?.type ?? ""}
                  linkToOrder={orderLinkToPath ?? ""}
                  orderDate={formattedOrders?.OrderDate ?? ""}
                  orderType={formattedOrders?.OrderType ?? ""}
                  placedBy={formattedOrders?.OrderPlacedBy ?? ""}
                  shippedTo={formattedOrders?.ShipToAccountName ?? ""}
                  shippingContact={formattedOrders?.ShipToContactName ?? ""}
                  shippingAddress={
                    formattedOrders
                      ? [
                          formattedOrders?.ShipAddressLine1,
                          formattedOrders?.ShipAddressLine2,
                          formattedOrders?.ShipCity,
                          formattedOrders?.ShipState,
                          formattedOrders?.ShipZip,
                        ]
                          .filter(Boolean)
                          .join(", ")
                      : ""
                  }
                  billedTo={formattedOrders?.BillToAccountName ?? ""}
                  apContact={accountDetails?.APContact ?? ""}
                  billingAddress={
                    formattedOrders
                      ? [
                          formattedOrders?.BillAddressLine1,
                          formattedOrders?.BillAddressLine2,
                          formattedOrders?.BillCity,
                          formattedOrders?.BillState,
                          formattedOrders?.BillZip,
                        ]
                          .filter(Boolean)
                          .join(", ")
                      : ""
                  }
                />
              </div>
              {/* {(userData.Type === "Admin" ||
                userData.Type === "ASD" ||
                userData.Type === "Authorizer" ||
                userData.Type === "Viewer") &&
                paymentsTableHeaders.length > 0 && (
                  <Table
                    // columnDefs={tableHeadersPaymentsAppliedInvoice}
                    // columnDefs={filteredTableHeadersPaymentsAppliedInvoice}
                    columnDefs={paymentsTableHeaders}
                    rowData={paymentsAppliedData}
                  />
                )} */}
            </div>

            {(userType === "Admin" ||
              userType === "Viewer" ||
              (userType === "Account" && invoiceNotesAccount?.Note) ||
              (userType === "Distributor" &&
                invoiceNotesDistributor?.Note)) && <Divider type="vertical" />}

            <div
              style={
                account?.noteText || distributor?.noteText
                  ? { display: "flex", flexDirection: "column" }
                  : {
                      display: "flex",
                      flexDirection: "column",
                    }
              }
            >
              <SectionHeader
                title="Notes"
                showButton={canShowAddNote}
                buttonLabel="Add Note"
                onButtonClick={() => setIsAddNoteOpen(true)}
                style={{ marginTop: 0 }}
              />
              <NotesSection
                invoiceData={invoiceData}
                invoiceNotesAccount={invoiceNotesAccount}
                invoiceNotesDistributor={invoiceNotesDistributor}
                userData={userData}
              />
              {(userType === "Admin" || userType === "Viewer") && (
                <CommentsSection
                  invoiceId={invoiceData?.ID}
                  invoiceComments={invoiceComments}
                  userData={userData}
                />
              )}
            </div>
          </div>
          {
            // (userData.Type === "Admin" ||
            //   userData.Type === "ASD" ||
            //   userData.Type === "Authorizer" ||
            //   userData.Type === "Viewer") &&
            paymentsTableHeaders.length > 0 && (
              <>
                <SectionHeader
                  title="Payments for this Invoice"
                  showButton={canShowAddPayment && canAddPayment}
                  buttonLabel="Add Payment"
                  onButtonClick={() => setModalOpenAddPayment(true)}
                />
                <Table
                  // columnDefs={tableHeadersPaymentsAppliedInvoice}
                  // columnDefs={filteredTableHeadersPaymentsAppliedInvoice}
                  columnDefs={paymentsTableHeaders}
                  rowData={paymentsAppliedData}
                />
              </>
            )
          }
        </>
      )}
      {selectedSegment === "Invoice Commissions" && (
        <>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "32px" }}
          >
            <CircularProgress
              commissionAppliedTillDate={
                invoiceCommissionData?.CommissionApplied
              }
              commissionableSale={invoiceCommissionData?.CommissionableSale}
              commissionRate={invoiceCommissionData?.ManufacturerCommissionAS}
              remainingBalance={invoiceCommissionData?.RemainingBalance}
              commissionReceived={invoiceCommissionData?.CommissionReceived}
              commissionReceivable={
                invoiceCommissionData?.ManufacturerCommissionReceivable
              }
            />
            <Divider />
            <div className="progress-container-numbers">
              <div className="progress-container-section">
                <Text variant="tinyText" color="lightText">
                  Distributor Commission Payable
                </Text>
                <Text variant="numberBig">
                  ${distCommPayable}
                  <Text variant="numbersSmall" color="strokeDark">
                    .{distCommPayableDecimal}
                  </Text>
                </Text>
                <Text variant="tinyText" color="lightText">
                  Sum of commission payable per product
                </Text>
              </div>
              <div className="progress-container-section">
                <Text variant="tinyText" color="lightText">
                  Distributor Commission Due Till Date
                </Text>
                <Text variant="numberBig">
                  ${distCommDue}
                  <Text variant="numbersSmall" color="strokeDark">
                    .{distCommDueDecimal}
                  </Text>
                </Text>
                <Text variant="tinyText" color="lightText">
                  Commission due to Distributor based on commission applied
                </Text>
              </div>
              <div className="progress-container-section">
                <Text variant="tinyText" color="lightText">
                  Remaining Commission Due
                </Text>
                <Text variant="numberBig">
                  ${commReceivable}
                  <Text variant="numbersSmall" color="strokeDark">
                    .{commReceivableDecimal}
                  </Text>
                </Text>
                <Text variant="tinyText" color="lightText">
                  Commission due to Distributor when remaining invoice is paid
                </Text>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "32px",
                alignItems: "flex-start",
                alignSelf: "stretch",
              }}
            >
              {invoiceCommissionData?.CommissionBreakdownNew.map((item) => {
                const productKey =
                  item?.InvoiceProductID ||
                  item?.TissueID ||
                  item?.ProductCode ||
                  "product";
                const distributorKey =
                  item?.DistributorID ||
                  item?.DistributorName ||
                  "missing-distributor";
                return (
                  <ProgressBox
                    key={`${productKey}-${distributorKey}`}
                    item={item}
                  />
                );
              })}
            </div>
          </div>
        </>
      )}
      </TabFade>
      {modalOpenEdit && (
        <ModalView
          isOpen={modalOpenEdit}
          onClose={() => setModalOpenEdit(false)}
          modalTitle="Edit Invoice"
          modalSubTitle={`Last edited on ${lastEdited} `}
          textInputComponent={
            <div className="field-group-wrapper">
              <div className="field-group">
                <TextInput
                  titleText="Invoice Number"
                  placeholder="Invoice Number"
                  value={invoiceNumberForm}
                  isRequired
                  setValue={setInvoiceNumberForm}
                />
                <TextInput
                  titleText="PO Number"
                  placeholder="PO Number"
                  value={poNumberForm}
                  isRequired
                  setValue={setPoNumberForm}
                />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                  }}
                >
                  <Text variant="tinyText">Upload Invoice</Text>
                  <div style={{ marginTop: 8 }}>
                    <Upload {...uploadProps}>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                  </div>
                </div>
              </div>
              <div className="field-group">
                <TextInput
                  titleText="Shipping Cost"
                  placeholder="Shipping Cost"
                  value={shippingCostForm}
                  isRequired
                  setValue={setShippingCostForm}
                />

                <DropdownComponent
                  label="Shipping Cost Assigned To"
                  placeholder="Shipping Cost Assigned To"
                  isRequired
                  options={[
                    { label: "Distributor", value: "distributor" },
                    { label: "Advanced Solution", value: "advanced-solution" },
                  ]}
                  value={shippingCostAssignedForm}
                  setValue={setShippingCostAssignedForm}
                />
              </div>
              <div className="field-group">
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText="Invoice Date"
                  isRequired
                  value={invoiceDateForm}
                  setValue={setInvoiceDateForm}
                />
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText="Due Date"
                  isRequired
                  value={dueDateForm}
                  setValue={setDueDateForm}
                />
              </div>
              <div className="field-group">
                <DropdownComponent
                  label="Invoice In Appeal"
                  placeholder="Invoice In Appeal"
                  isRequired
                  options={[
                    { label: "Yes", value: "invoice-appeal-yes" },
                    { label: "No", value: "invoice-appeal-no" },
                  ]}
                  value={invoiceAppealForm}
                  setValue={setInvoiceAppealForm}
                />
              </div>

              <div className="field-group">
                {invoiceData?.IsVoided && (
                  <TextInput
                    titleText="Credit Memo"
                    placeholder="Credit Memo"
                    className="width-button"
                    isRequired
                    value={creditMemoForm}
                    setValue={setCreditMemoForm}
                  />
                )}
              </div>
            </div>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={submitHandler}
              >
                Save
              </CommonButton>
            </div>
          }
        />
      )}

      {modalOpenVoid && (
        <ModalView
          isOpen={modalOpenVoid}
          onClose={() => setModalOpenVoid(false)}
          modalTitle="Are you sure you want to void this invoice?"
          textInputComponent={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "32px",
              }}
            >
              <Text>
                This will mark all the products in this invoice as returned. The
                products will not appear in the account's product log, and this
                invoice data will not contribute to calculating any sales data.
              </Text>
              <TextInput
                titleText="Credit Memo"
                placeholder="Credit Memo"
                className="width-button"
                isRequired
                value={tempCreditMemo}
                setValue={setTempCreditMemo}
              />
            </div>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="failure"
                onClick={handleOk}
              >
                Void
              </CommonButton>
            </div>
          }
        />
      )}

      {modalOpenCollections && (
        <ModalView
          isOpen={modalOpenCollections}
          onClose={() => setModalOpenCollections(false)}
          modalTitle="Send Products To Collections"
          textInputComponent={
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Text>
                Select the invoice products to send to collections. Returned
                products, return-in-progress products, products with commission
                applied, and products already sent to collections cannot be
                selected.
              </Text>
              <Checkbox
                checked={allEligibleCollectionProductsSelected}
                disabled={eligibleCollectionProductIds.length === 0}
                onChange={toggleAllEligibleCollectionProducts}
              >
                Select all eligible products
              </Checkbox>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                  maxHeight: "360px",
                  overflowY: "auto",
                }}
              >
                {collectionProducts.map((product) => {
                  const priceValue = Number(product?.Price ?? 0);
                  const disabled = Boolean(product.collectionDisabledReason);
                  return (
                    <div
                      key={product.ID}
                      style={{
                        border: "1px solid #E5E5E5",
                        borderRadius: "8px",
                        padding: "12px 16px",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <Checkbox
                        checked={selectedCollectionProductIds.includes(
                          product.ID,
                        )}
                        disabled={disabled}
                        onChange={() => toggleCollectionProduct(product.ID)}
                      >
                        <Text variant="bodyText">
                          {product?.TissueID || `Product ${product.ID}`}{" "}
                          {product?.ProductCode
                            ? `(${product.ProductCode})`
                            : ""}
                        </Text>
                      </Checkbox>
                      <Text color="lightText">
                        {formatCurrency(priceValue)}
                      </Text>
                      {disabled && (
                        <Text color="failureColor">
                          {product.collectionDisabledReason}
                        </Text>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              <CommonButton
                variant="ghost"
                onClick={() => setModalOpenCollections(false)}
              >
                Cancel
              </CommonButton>
              <CommonButton
                variant="table"
                subVariant="warning"
                onClick={submitSendToCollections}
                disabled={
                  isSendingToCollections ||
                  selectedCollectionProductIds.length === 0
                }
              >
                Send To Collections
              </CommonButton>
            </div>
          }
        />
      )}

      {modalOpenApplyCommFull && (
        <ModalView
          isOpen={modalOpenApplyCommFull}
          onClose={() => setModalOpenApplyCommFull(false)}
          modalTitle="Apply Commission In Full"
          textInputComponent={
            commContractAlert ? (
              <div className="modal-alert-container">
                <div className="modal-alert-content">
                  <FailureIcon
                    className="delete-icon-container"
                    width={16}
                    height={16}
                  />
                  <Text>
                    {commContractAlertData?.ContractExists === false && (
                      <>
                        Commission cannot be applied to this invoice because no
                        valid commission contract exists for{" "}
                        {invoiceData?.DistributorName} on Invoice Date{" "}
                        {moment(invoiceData?.InvoiceDate).format("MM-DD-YYYY")}.
                        Please create a new commission contract to proceed.
                      </>
                    )}
                    {commContractAlertData?.ContractExists === true &&
                      commContractAlertData?.ContractProductExists ===
                        false && (
                        <>
                          Commission cannot be applied to this invoice because
                          product {commContractAlertData?.ProductGroupName} (ID:{" "}
                          {commContractAlertData?.ProductGroupID}) does not
                          exist in the commission contract (ID:{" "}
                          {commContractAlertData?.CommissionContractID}) for
                          this distributor. Please update the commission
                          contract to proceed.
                        </>
                      )}
                    {commContractAlertData?.ContractExists === true &&
                      commContractAlertData?.ContractProductExists === true &&
                      commContractAlertData?.CommissionZero === true && (
                        <>
                          Commission cannot be applied to this invoice because
                          product {commContractAlertData?.ProductGroupName} (ID:{" "}
                          {commContractAlertData?.ProductGroupID}) rate is set
                          at 0% in the commission contract (ID:{" "}
                          {commContractAlertData?.CommissionContractID}) for
                          this distributor. Please update the commission
                          contract to proceed.
                        </>
                      )}
                  </Text>
                </div>
              </div>
            ) : (
              <div className="field-group-wrapper">
                <div className="field-group">
                  <DatePickerComponent
                    format="MM-DD-YYYY"
                    titleText="Date Applied"
                    isRequired
                    disabledDate={(currentDate) => {
                      // Disable if before minDateApplied or after maxDateApplied
                      if (!minDateApplied || !maxDateApplied) return true;
                      return (
                        currentDate.isBefore(minDateApplied.startOf("day")) ||
                        currentDate.isAfter(maxDateApplied.endOf("day"))
                      );
                    }}
                    value={appliedDate}
                    onChange={handleAppliedDateChange}
                  />
                  <TextInput
                    titleText="Statement Month"
                    placeholder="Statement Month"
                    isRequired
                    value={statementMonthComm}
                    setValue={setStatementMonthComm}
                    isDisabled={true}
                  />
                </div>
              </div>
            )
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              {commContractAlert ? (
                <a
                  href="/CommissionContract"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="nav-link"
                >
                  <CommonButton
                    variant="table"
                    subVariant="primary"
                    icon={<RightTopArrowIcon />}
                  >
                    Create New Commission Contract
                  </CommonButton>
                </a>
              ) : (
                <CommonButton
                  variant="table"
                  subVariant="success"
                  onClick={() => applyCommissionInFull(appliedDate)}
                  disabled={!appliedDate}
                >
                  Apply Commission in Full
                </CommonButton>
              )}
            </div>
          }
        />
      )}

      {isAddNoteOpen && (
        <ModalView
          isOpen={isAddNoteOpen}
          onClose={() => setIsAddNoteOpen(false)}
          modalTitle="Add note"
          textInputComponent={
            <div className="field-group-wrapper">
              <DropdownComponent
                label="To:"
                labelType="left"
                placeholder="Select one"
                isRequired
                options={noteOptions}
                value={isNoteTypeSelected}
                setValue={setIsNoteTypeSelected}
              />
              <div className="add-note-model-input-container">
                <textarea
                  className="add-note-textarea"
                  placeholder="Add a note"
                  maxLength={1000}
                  value={noteContent}
                  onChange={(e) => setNoteContent(e.target.value)}
                />
                <div className="comments-individual-header-left">
                  <Checkbox
                    checked={isNotifyCheck}
                    onClick={() => setIsNotifyCheck(!isNotifyCheck)}
                  />
                  <Text variant="smallText">
                    Notify {isNoteTypeSelected?.label} via email
                  </Text>
                </div>
              </div>
            </div>
          }
          footerButtonWrapper={
            <div
              className="footer-button-wrapper-flex-end"
              style={{ gap: "12px" }}
            >
              <CommonButton
                variant="table"
                subVariant="outline"
                onClick={() => setIsAddNoteOpen(false)}
              >
                Cancel
              </CommonButton>
              <CommonButton
                variant="table"
                subVariant="primary"
                onClick={addNote}
              >
                Add
              </CommonButton>
            </div>
          }
        />
      )}
      {isInvoiceFilesModalOpen && (
        <ModalView
          isOpen={isInvoiceFilesModalOpen}
          onClose={() => setIsInvoiceFilesModalOpen(false)}
          modalTitle="View all Invoice Files"
          maxWidth="920px"
          minWidth="720px"
          textInputComponent={
            <div className="invoice-files-modal-container">
              <Text variant="smallText" color="lightText">
                Here are the invoice files that were previously attached.
              </Text>
              {isInvoiceFilesLoading ? (
                <div className="invoice-files-modal-empty-state">
                  <Text variant="smallText">Loading invoice files...</Text>
                </div>
              ) : invoiceFilesError ? (
                <div className="invoice-files-modal-empty-state">
                  <Text variant="smallText" color="failureColor">
                    {invoiceFilesError}
                  </Text>
                </div>
              ) : invoiceFilesModalRows.length === 0 ? (
                <div className="invoice-files-modal-empty-state">
                  <Text variant="smallText">
                    No invoice files have been attached yet.
                  </Text>
                </div>
              ) : (
                <div className="invoice-files-modal-table">
                  <Table
                    rowData={invoiceFilesModalRows}
                    columnDefs={invoiceFilesModalColumns}
                    pagination={invoiceFilesModalRows.length > 20}
                  />
                </div>
              )}
            </div>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper-flex-end">
              <CommonButton
                variant="table"
                subVariant="outline"
                onClick={() => setIsInvoiceFilesModalOpen(false)}
              >
                Close
              </CommonButton>
            </div>
          }
        />
      )}
      {modalOpenMakePayment && (
        <MakeInvoicePaymentModal
          isOpen={modalOpenMakePayment}
          onClose={() => setModalOpenMakePayment(false)}
          invoiceData={invoiceData}
          invoiceTotal={invoiceTotalWithCharges}
          totalPaymentsApplied={totalPaymentsApplied}
          openBalance={normalizedOpenBalance}
          statusText={statusIndicatorText.text}
          onCheckout={handleCreateInvoiceCheckout}
          isSubmitting={isCreatingInvoiceCheckout}
        />
      )}
      {canAddPayment && modalOpenAddPayment && (
        <ModalView
          isOpen={modalOpenAddPayment}
          onClose={() => setModalOpenAddPayment(false)}
          modalTitle="Add Payment"
          textInputComponent={
            <div className="field-group-wrapper">
              <div className="field-group">
                <DatePickerComponent
                  format="MM-DD-YYYY"
                  titleText="Date Applied"
                  isRequired
                  // value={paymentsModalData ? moment(paymentsModalData.AppliedDate) : appliedDate}
                  value={appliedDatePayment}
                  // disabledDate={(currentDate) => {
                  //   return (
                  //     currentDate &&
                  //     currentDate >= minDateApplied.startOf("day") &&
                  //     currentDate <= maxDateApplied.startOf("day")
                  //   );
                  // }}
                  // onChange={setAppliedDatePayment}
                  onChange={(date) => setAppliedDatePayment(date)}
                />
                <DropdownComponent
                  label="Payment Type"
                  placeholder="Payment Type"
                  isRequired
                  options={[
                    { label: "Check", value: "Check" },
                    { label: "Wire", value: "Wire" },
                    { label: "ACH", value: "ACH" },
                    { label: "Credit Card", value: "Credit Card" },
                    { label: "Bank Transfer", value: "Bank Transfer" },
                    { label: "Settlement", value: "Settlement" },
                  ]}
                  value={paymentType}
                  setValue={setPaymentType}
                />
                <TextInput
                  titleText="Transaction ID / Check Number"
                  placeholder="Transaction ID / Check Number"
                  isRequired
                  // value={paymentsModalData ? paymentsModalData.CheckNumber : checkNumber}
                  value={checkNumber}
                  setValue={setCheckNumber}
                />
                <TextInput
                  titleText="Payment Amount"
                  placeholder="Payment Amount"
                  value={appliedTotal}
                  //  value={paymentsModalData ? paymentsModalData.AppliedTotal : appliedTotal}
                  isRequired
                  onChange={(e) => handleAppliedTotal(e.target.value)}
                  errorText={appliedTotalError}
                />
              </div>
            </div>
          }
          footerButtonWrapper={
            <div className="footer-button-wrapper">
              <CommonButton
                variant="table"
                subVariant="success"
                onClick={handlePaymentsOk}
                disabled={
                  !(
                    canAddPayment &&
                    canShowAddPayment &&
                    appliedDatePayment &&
                    checkNumber?.trim() &&
                    paymentType &&
                    !appliedTotalError &&
                    Number.isFinite(Number(appliedTotal)) &&
                    roundToTwo(Number(appliedTotal)) > 0
                  )
                }
              >
                Add Payment
              </CommonButton>
            </div>
          }
        />
      )}
      {invoiceData && (
        <ApplyCommission
          handleApplyCommModal={handleApplyCommModal}
          modalOpenApplyComm={modalOpenApplyComm}
          invoiceData={invoiceData}
          invoiceCommissionData={invoiceCommissionData}
          invoiceHomeData={invoiceHomeData}
          commContractAlert={commContractAlert}
          commContractAlertData={commContractAlertData}
          distInvCommPercentage={distInvCommPercentage}
          isDistInvCommPercentageLoading={isDistInvCommPercentageLoading}
        />
      )}
      {modalOpenResetCommission && (
        <ModalView
          isOpen={modalOpenResetCommission}
          onClose={() => setModalOpenResetCommission(false)}
          modalTitle="Reset Commission"
          modalSubTitle="Select a commission row to reset. Generated statement rows are locked."
          maxWidth="1180px"
          minWidth={isPhone ? "320px" : "900px"}
          textInputComponent={
            <Table
              columnDefs={resetCommissionColumns}
              rowData={resetCommissionRows}
            />
          }
        />
      )}
      <ModalView
        isOpen={modalOpenEditPayment}
        onClose={() => setModalOpenEditPayment(false)}
        modalTitle="Edit Payment"
        textInputComponent={
          <div className="field-group-wrapper">
            <div className="field-group">
              <DatePickerComponent
                format="MM-DD-YYYY"
                titleText="Date Applied"
                isRequired
                value={dayjs(paymentsModalData?.AppliedDate) ?? dayjs()}
                isDisabled={true}
              />
              <DropdownComponent
                label="Payment Type"
                placeholder="Payment Type"
                isRequired
                options={[
                  { label: "Check", value: "Check" },
                  { label: "Wire", value: "Wire" },
                  { label: "ACH", value: "ACH" },
                  { label: "Credit Card", value: "Credit Card" },
                  { label: "Bank Transfer", value: "Bank Transfer" },
                  { label: "Settlement", value: "Settlement" },
                ]}
                value={
                  editPaymentType ?? {
                    value: paymentsModalData?.PaymentType,
                    label: paymentsModalData?.PaymentType,
                  }
                }
                setValue={setEditPaymentType}
              />
              <TextInput
                titleText="Transaction ID / Check Number"
                placeholder="Transaction ID / Check Number"
                isRequired
                // value={
                //   paymentsModalData
                //     ? paymentsModalData?.CheckNumber
                //     : checkNumber
                // }
                value={editCheckNumber ?? paymentsModalData?.CheckNumber}
                setValue={setEditCheckNumber}
                disabled={paymentsModalData ? true : false}
              />
              <TextInput
                titleText="Payment Amount"
                placeholder="Payment Amount"
                value={editAppliedTotal ?? paymentsModalData?.AppliedTotal}
                isRequired
                setValue={setEditAppliedTotal}
                disabled={paymentsModalData ? true : false}
              />
            </div>
          </div>
        }
        footerButtonWrapper={
          <div className="footer-button-wrapper">
            <CommonButton
              variant="table"
              subVariant="success"
              onClick={handleUpdatePayments}
            >
              Save
            </CommonButton>
            {userData.Type === "Admin" && hasPermission(userData, "payment.delete") && (
              <CommonButton
                variant="table"
                subVariant="failure"
                onClick={handleDeletePayment}
              >
                Delete
              </CommonButton>
            )}
          </div>
        }
      />
    </div>
  );
};

export default InvoiceHome;
